<div class="m-t-4">
    <div class="text-center" *ngIf="loading">
        <app-loading [showText]="false"></app-loading>
    </div>
    <div *ngIf="!loading" class="d-flex gap-4 flex-wrap align-items-center">
        <ng-container *ngFor="let item of items">
            <app-chip *ngIf="onlyShowSelectedDisplayOthers || !onlyShowSelected || item.selected"
                    [chip]="item"
                      [disabled]="disabled"
                      [canUnSelect]="!forceOneSelection"
                      (focussedEvent)="focussedEvent.emit()"
                      (selectedChangedEvent)="selectedChanged($event)"></app-chip>
        </ng-container>
        <i-tabler name="dots-circle-horizontal" class="icon-16 cursor-pointer chips-more" *ngIf="!onlyShowSelectedDisplayOthers && onlyShowSelected && items?.length > 1" (click)="onlyShowSelectedDisplayOthers = true"></i-tabler>
    </div>
</div>